import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Pagination } from 'swiper/core'

Swiper.use([Navigation, Pagination])

export default class extends Controller {
  static targets = ['swiper', 'prevBtn', 'nextBtn', 'pagination']

  get className () {
    return this.element.dataset.classname || ''
  }

  // Swiper の .swiper-slide { width: 100% } との CSS カスケード競合を避けるため、
  // スライド幅をJSで明示的に設定する（production bundle順に依存しない）
  setSlideWidths () {
    if (!this.swiper) return
    const containerWidth = this.swiper.el.offsetWidth
    if (containerWidth === 0) return
    const slideWidth = containerWidth - 60 // 両端30px確保（CSSの calc(100% - 60px) と同期）
    Array.from(this.swiper.slides).forEach(slide => {
      slide.style.width = `${slideWidth}px`
    })
  }

  connect () {
    if (!this.hasSwiperTarget) return

    try {
      this.swiper = new Swiper(this.swiperTarget, {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        autoHeight: true,
        navigation: {
          nextEl: this.hasNextBtnTarget ? this.nextBtnTarget : null,
          prevEl: this.hasPrevBtnTarget ? this.prevBtnTarget : null,
        },
        pagination: {
          el: this.hasPaginationTarget ? this.paginationTarget : null,
          clickable: true,
          bulletActiveClass: `${this.className}::active`,
        },
        on: {
          // リサイズ・画面回転時にスライド幅を再計算
          resize: () => {
            this.setSlideWidths()
          },
        },
      })
      this.setSlideWidths()
      this.swiper.update()
    } catch (error) {
      console.error('[Campaign Swiper] 初期化に失敗しました:', error)
    }
  }

  disconnect () {
    this.swiper?.destroy()
  }

  toggleCard (event) {
    const card = event.currentTarget.closest('[data-classname]')
    if (!card) return
    card.classList.toggle(`${card.dataset.classname}::card--open`)
    this.swiper?.update()
  }
}
